import React from "react";
import { FAMILY_TONE } from "./vocab";

export function ContextChip({ id, byId, testId }) {
    const c = byId?.[id];
    const tone = FAMILY_TONE[c?.family] || FAMILY_TONE.other;
    return (
        <span data-testid={testId} title={c?.description || id}
            className={`px-1.5 py-0.5 rounded-sm border text-[10px] font-mono whitespace-nowrap ${tone} ${c && !c.active ? "line-through opacity-70" : ""}`}>
            {c?.label || id}
        </span>
    );
}

export function ContextChips({ contexts, byId, max = 3, itemId }) {
    const list = contexts || [];
    if (!list.length) return null;
    return (
        <div className="flex flex-wrap gap-1" data-testid={`dl-contexts-${itemId}`}>
            {list.slice(0, max).map((id) => <ContextChip key={id} id={id} byId={byId} testId={`dl-context-chip-${itemId}-${id}`} />)}
            {list.length > max && <span className="text-[10px] font-mono text-white/40">+{list.length - max}</span>}
        </div>
    );
}
